
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Home',
  data: () => ({

  }),
  computed: {
    standalonePolicy () {
      return this.$store.state.claimform.standalonePolicy
    },
    standalonePolicyGadgets () {
      return this.$store.state.claimform.standalonePolicy.gadgets
    },
    isPolicyholder () {
      return true
    },
    policyNumber () {
      return this.$store.state.claimform.claimForm.data.policy.number
    },
    claimForm () {
      return this.$store.state.claimform.claimForm
    },
    claim () {
      return this.$store.state.claimform.claimForm.data
    },
    claimant () {
      return this.$store.state.claimform.claimForm.data.claimant
    },
    gadgets () {
      return this.$store.state.claimform.claimForm.data.gadgets
    },
    countries () {
      return this.$store.state.claimform.countries
    },
    documentTypes () {
      return this.$store.state.claimform.documentTypes
    },
    ...mapGetters({
      coveredGadgets: 'claimform/getCoveredGadgets',
      gadgetIndexByItemGUID: 'claimform/gadgetIndexByItemGUID',
      selectedIncidentTypeL1: 'claimform/selectedIncidentTypeL1',
      selectedIncidentTypeL2: 'claimform/selectedIncidentTypeL2',
      selectedIncidentTypeL3: 'claimform/selectedIncidentTypeL3',
      selectedIncidentTypeId: 'claimform/selectedIncidentTypeId',
      isFastTrackable: 'claimform/isFastTrackable',
      claimReference: 'claimform/claimReference',
      claimFormGadgets: 'claimform/claimFormGadgets',
      underwriter: 'claimform/getUnderwriter'
    })

  },
  methods: {
    ...mapActions({
      setClaimant: 'claimform/setClaimant',
      setClaimantCheckForUser: 'claimform/setClaimantCheckForUser',
      setClaimantAndSavedEmail: 'claimform/setClaimantAndSavedEmail',
      setClaimantIdentificationNumber: 'claimform/setClaimantIdentificationNumber',
      setPolicy: 'claimform/setPolicy',
      setStandalonePolicy: 'claimform/setStandalonePolicy',
      setStandalonePolicy2: 'claimform/setStandalonePolicy2',
      setAltTelephone: 'claimform/setAltTelephone',
      setSelectedIncidentType: 'claimform/setSelectedIncidentType',
      setResidency: 'claimform/setResidency',
      setTaxStatus: 'claimform/setTaxStatus',
      setOccurredAbroad: 'claimform/setOccurredAbroad',
      // fetchCountries:'claimform/fetchCountries',
      setTripDetails: 'claimform/setTripDetails',
      addUpdateGadget: 'claimform/addUpdateGadget',
      removeGadget: 'claimform/removeGadget',
      setIncidentDetails: 'claimform/setIncidentDetails',
      setClaimFormReference: 'claimform/setClaimFormReference',
      fetchDocumentTypes: 'claimform/fetchDocumentTypes',
      fetchDocumentTypesV2: 'claimform/fetchDocumentTypesV2',
      setDocuments: 'claimform/setDocuments',
      setOtherClaims: 'claimform/setOtherClaims',
      setAgreeDataProtection: 'claimform/setAgreeDataProtection',
      setAgreeFraud: 'claimform/setAgreeFraud',
      setAgreeDeclaration: 'claimform/setAgreeDeclaration',
      incrementProgress: 'claimform/incrementProgress',
      setSavedEmail: 'claimform/setSavedEmail',
      setInsuranceLineId: 'claimform/setInsuranceLineId',
      setClaimReference: 'claimform/setClaimReference',
      setSubmissionResponse: 'claimform/setSubmissionResponse',
      setCountries: 'claimform/setCountries',
      setInProgressForms: 'claimform/setInProgressForms',
      getInProgressForms: 'claimform/getInProgressFormsList',
      setInProgressForm: 'claimform/setInProgressForm',
      reset: 'claimform/reset',
      setUnderwriter: 'claimform/setUnderwriter',
      getUnderwriter: 'claimform/getUnderwriter'
    })
  }
}
